import { render } from "./ReleaseDialog.vue?vue&type=template&id=fcba47e2&scoped=true"
import script from "./ReleaseDialog.vue?vue&type=script&lang=js"
export * from "./ReleaseDialog.vue?vue&type=script&lang=js"

import "./ReleaseDialog.vue?vue&type=style&index=0&id=fcba47e2&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcba47e2"]])

export default __exports__